import React from "react";
import { Slide } from "react-toastify";

import * as S from "./toaster.styles";
import "react-toastify/dist/ReactToastify.min.css";

const DEFAULT_TIMEOUT = 5000;

export const Toaster = (props) => (
  <S.StyledToastContainer
    position="top-right"
    autoClose={DEFAULT_TIMEOUT}
    transition={Slide}
    hideProgressBar
    newestOnTop
    closeOnClick
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />
);
